// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__x-a_U","vLegacy":"SelectSecondary_vLegacy__2-wDn","error":"SelectSecondary_error__3aTwZ","disabled":"SelectSecondary_disabled__LyGnX"};